"use strict";
import { Loading } from 'element-ui';
import { Notification } from 'element-ui'
import Vue from 'vue';
import axios from "axios";
import { getToken } from '@/plugins/auth' // getToken from cookie

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
let config = {
    //baseURL: "http://localhost:2222/"
    baseURL: "https://zz.api.akcywy.com"
    // || process.env.apiUrl || ""
    // timeout: 60 * 1000, // Timeout
    // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);
let loadingInstance = null
let notificationInstance = null
_axios.interceptors.request.use(
    function (config) {
        if (getToken()) {
            config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
        }
        config.headers['Content-Type'] = 'application/json'
        // Do something before request is sent
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    }
);
// Add a response interceptor
_axios.interceptors.response.use(
    response => {
        if (response.status < 200 || response.status > 300) {
            notificationInstance = Notification({
                title: '服务端错误',
                message: response.statusText,
                type: 'error'
            })
        } else {
            return response.data
        }
    },
    function (error) {
        // Do something with response error
        notificationInstance = Notification({
            title: '服务端错误',
            message: error,
            type: 'error'
        })
        return Promise.reject(error);
    }
);

Plugin.install = function (Vue, options) {
    Vue.axios = _axios;
    window.axios = _axios;
    Object.defineProperties(Vue.prototype, {
        axios: {
            get() {
                return _axios;
            }
        },
        $axios: {
            get() {
                return _axios;
            }
        },
    });
};

Vue.use(Plugin)

export default Plugin;
